/*
* Broadcast Theme
*
* Custom behaviour for THE RESET EVENT.
*/

(function() {
  const GIFT_VARIANT_ID = 57733235409244;
  const GIFT_THRESHOLD_CENTS = 15000;
  const EVENT_START = Date.parse('2026-07-19T10:00:00Z');
  const EVENT_END = Date.parse('2026-07-31T22:00:59Z');
  const GIFT_PROPERTY = '_reset_event_gift';
  const originalFetch = window.fetch.bind(window);
  let syncing = false;
  let scheduledSync = null;

  function eventIsActive() {
    const now = Date.now();
    return now >= EVENT_START && now <= EVENT_END;
  }

  function isCartRequest(input) {
    const url = typeof input === 'string' ? input : input && input.url;
    return typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(url);
  }

  function refreshCart() {
    document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
  }

  async function getCart() {
    const response = await originalFetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Unable to read cart');
    return response.json();
  }

  async function updateLine(key, quantity) {
    const response = await originalFetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    });
    if (!response.ok) throw new Error('Unable to update gift');
    return response.json();
  }

  async function addGift() {
    const response = await originalFetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{
          id: GIFT_VARIANT_ID,
          quantity: 1,
          properties: { [GIFT_PROPERTY]: 'true' }
        }]
      })
    });
    if (!response.ok) throw new Error('Unable to add gift');
    return response.json();
  }

  async function syncGift() {
    if (syncing) return;
    syncing = true;

    try {
      const cart = await getCart();
      const giftLines = cart.items.filter(item => Number(item.variant_id) === GIFT_VARIANT_ID);
      const automaticGiftLines = giftLines.filter(
        item => item.properties && item.properties[GIFT_PROPERTY] === 'true'
      );
      const qualifyingSubtotal = cart.items.reduce((total, item) => {
        if (Number(item.variant_id) === GIFT_VARIANT_ID) return total;
        return total + Number(item.original_line_price || item.final_line_price || 0);
      }, 0);
      const qualifies = eventIsActive() && qualifyingSubtotal >= GIFT_THRESHOLD_CENTS;

      let changed = false;

      if (qualifies) {
        if (giftLines.length === 0) {
          await addGift();
          changed = true;
        } else {
          let giftKept = false;
          for (const line of giftLines) {
            if (!giftKept) {
              giftKept = true;
              if (line.quantity !== 1) {
                await updateLine(line.key, 1);
                changed = true;
              }
            } else {
              await updateLine(line.key, 0);
              changed = true;
            }
          }
        }
      } else {
        for (const line of automaticGiftLines) {
          await updateLine(line.key, 0);
          changed = true;
        }
      }

      if (changed) refreshCart();
    } catch (error) {
      console.warn('THE RESET EVENT gift could not be synchronized.', error);
    } finally {
      syncing = false;
    }
  }

  function scheduleGiftSync() {
    window.clearTimeout(scheduledSync);
    scheduledSync = window.setTimeout(syncGift, 120);
  }

  window.fetch = async function() {
    const request = arguments[0];
    const response = await originalFetch.apply(window, arguments);
    if (!syncing && isCartRequest(request)) scheduleGiftSync();
    return response;
  };

  document.addEventListener('DOMContentLoaded', syncGift);
  document.addEventListener('theme:product:add', scheduleGiftSync);
  document.addEventListener('theme:cart:update', scheduleGiftSync);
  if (window.subscribe && window.theme && window.theme.PUB_SUB_EVENTS) {
    window.subscribe(window.theme.PUB_SUB_EVENTS.cartUpdate, scheduleGiftSync);
  }
})();
